(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 740px)');

  function bindCarousel(scroller) {
    if (scroller.dataset.mobileCarouselReady === 'true') return;

    const section = scroller.closest('.shopify-section');
    const progress = section?.querySelector('[data-mobile-progress]');
    const indicators = Array.from(progress?.children || []);
    if (!indicators.length) return;

    let animationFrame;

    const update = () => {
      animationFrame = undefined;
      if (!MOBILE_QUERY.matches) return;

      const offsets = [...new Set(Array.from(scroller.children).map((card) => card.offsetLeft))].sort((a, b) => a - b);
      if (!offsets.length) return;

      const current = offsets.reduce((closest, offset, index) => {
        const distance = Math.abs(offset - scroller.scrollLeft);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;

      indicators.forEach((indicator, index) => {
        indicator.classList.toggle('is-active', index === Math.min(current, indicators.length - 1));
      });
    };

    scroller.addEventListener('scroll', () => {
      if (!animationFrame) animationFrame = requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });
    scroller.dataset.mobileCarouselReady = 'true';
    update();
  }

  function init(root = document) {
    root.querySelectorAll('[data-mobile-carousel]').forEach(bindCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
